export function getLineAxisPointer() {
    const axisPointer = {
        show: true,
        type: 'line',
        lineStyle: {
            color: '#555',
            width: 0
        }
    }
    return axisPointer;
}
type axisPointerType = "shadow" | "line" | "none" | "cross";
export function getShadowAxisPointer() {
    const axisPointer = {
        show: true,
        type: 'shadow' as axisPointerType,
        shadowStyle: {
            // color: 'rgba(150,150,150,0.3)',
            color: 'rgba(204,214,235,0.25)',
        }
    }
    return axisPointer;
}
export function getCrossAxisPointer() {
    const acrossPointer = {
        show: true,
        type: 'cross' as axisPointerType,
        
    }
    return acrossPointer
}
